import { RouteRecordRaw } from 'vue-router';

import { popQueryOrParam } from '@/helpers/routerUtils';
import { LazyComponent } from '@/models/LazyComponent';

const propostaQuitada: LazyComponent = () => import(/* webpackChunkName: "propostas" */ './views/PropostaQuitada.vue');

export const routes: RouteRecordRaw[] = [
  {
    path: '/propostas/:api/:idProposta/quitada',
    name: 'propostas-quitadas',
    component: propostaQuitada,
    props: (route) => {
      const api = popQueryOrParam(route.params.api);
      const idProposta = popQueryOrParam(route.params.idProposta);

      return {
        api,
        idProposta: Number(idProposta),
      };
    },
  },
];

export default routes;
